export default __webpack_public_path__ + "static/media/mastery-test-icon.52e28918.png";